import { database } from './firebase';
import { getURL } from './storage';

export const fetchDocumentURLArray = async (id: string): Promise<string[]> => {
  const doc = await database.collection('scores').doc(id).get();
  const data = doc.data();
  if (data) {
    const chapterCount = 8;
    const urlPromises = Array.from(Array(chapterCount).keys()).map((index) => {
      if (data[`chapter${index + 1}`] !== undefined) {
        return getURL(`files/chapter-${index + 1}`);
      }
    });
    const urlArr = await Promise.all(urlPromises);
    return urlArr;
  } else {
    return [];
  }
};
